import { render, staticRenderFns } from "./UsaIndex.vue?vue&type=template&id=71b513c3&scoped=true&"
import script from "./UsaIndex.vue?vue&type=script&lang=js&"
export * from "./UsaIndex.vue?vue&type=script&lang=js&"
import style0 from "./UsaIndex.vue?vue&type=style&index=0&id=71b513c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b513c3",
  null
  
)

export default component.exports